import { Grid, RadioGroupInput } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

export default function Step() {
  return (
    <StepWrapper
      name="Huur betaald door de vennootschap"
      description="Betaalt de vennootschap huur aan u als privé persoon?"
      maxWidth={1000}
    >
      <Grid container spacing={2}>
        <RadioGroupInput
          name="vennootschap_huur_prive"
          items={[
            { text: 'Ja', value: 'ja' },
            { text: 'Nee', value: 'nee' },
          ]}
          xs={12}
          required
        />
      </Grid>
    </StepWrapper>
  );
}
